import React, { useEffect, useState } from "react";
import baseUrl from "../../api/universalApi";
import { useSelector } from "react-redux";

const ViewContract = ({ agreementData}) => {

//  console.log("campaignId",campaignId)
  const contract = agreementData;

  const user = useSelector((state) => state.auth?.authData?.user);
 // console.log("User Data:", user);

  const formatDate = (dateStr) =>
    dateStr ? new Date(dateStr).toLocaleDateString() : "--";

  return (
    <>
    <div
        className="w-full bg-gray-200  mx-auto space-y-6"
        style={{ fontFamily: "Gilroy-Medium" }}
      >
          <div className="bg-white  w-full">
          <h2 className="text-lg font-semibold mb-4">Contract Details</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <span className="font-medium">Publish Date:</span>{" "}
              <span className="text-gray-700">
                {formatDate(contract?.publish_date)}
              </span>
            </div>
            <div>
              <span className="font-medium">Final Amount:</span>{" "}
              <span className="text-gray-700">{contract?.amount || "--"}</span>
            </div>
            <div>
              <span className="font-medium">Company Name:</span>{" "}
              <span className="text-gray-700">{contract?.company || "--"}</span>
            </div>
            <div>
              <span className="font-medium">Collaterals/Deliverables:</span>{" "}
              <span className="text-gray-700">
                {contract?.deliverables || "--"}
              </span>
            </div>
            <div>
              <span className="font-medium">Payment Type:</span>{" "}
              <span className="text-gray-700">
                {contract?.paymentType || "--"}
              </span>
            </div>
            <div>
              <span className="font-medium">Start Date:</span>{" "}
              <span className="text-gray-700">
                {formatDate(contract?.start_date)}
              </span>
            </div>
            <div>
              <span className="font-medium">End Date:</span>{" "}
              <span className="text-gray-700">
                {formatDate(contract?.end_date)}
              </span>
            </div>
          </div>

          <div className="mt-6">
            <h3 className="text-lg font-semibold">Signatures</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
              <div>
                <span className="font-medium">Creator Signature:</span>{" "}
                <span className="text-gray-700">
                  {contract?.creator_signature || "--"}
                </span>
              </div>
              <div>
                <span className="font-medium">
                  Brand Representative Signature:
                </span>{" "}
                <span className="text-gray-700">
                  {contract?.rep_signature || "--"}
                </span>
              </div>
              <div>
                <span className="font-medium">Brand Representative Email:</span>{" "}
                <span className="text-gray-700">
                  {contract?.rep_email || "--"}
                </span>
              </div>

               {contract?.agreement_file && (
                <>
                  <div>
                    <span className="font-medium">Contract File</span>{" "}
                    <span className="text-gray-700">
                      <a
                        href={contract?.agreement_file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 text-xs mt-1"
                      >
                        View current file
                      </a>
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

       
      </div>

     
    </>
  );
};

export default ViewContract;
